import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19143458"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height", "viewBox"]

import { PropType, Ref, ref } from 'vue';
import { LoaderSize } from '@/enums/loader';
import AppLoaderBackdrop from '@/components/Base/AppLoader/AppLoaderBackdrop.vue';
import AppLoaderCircle from '@/components/Base/AppLoader/AppLoaderCircle.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLoader',
  props: {
  size: {
    type: String as PropType<LoaderSize>,
    default: LoaderSize.MEDIUM,
  },
  overlay: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const size: Ref<number> = ref(0);
const radius: Ref<number> = ref(0);

if (!size.value || !radius.value) {
  switch (props.size) {
    case LoaderSize.EXTRA_SMALL:
      size.value = 16;
      radius.value = 1.28;
      break;
    case LoaderSize.SMALL:
      size.value = 22;
      radius.value = 1.76;
      break;
    case LoaderSize.MEDIUM:
      size.value = 30;
      radius.value = 2.4;
      break;
    case LoaderSize.LARGE:
      size.value = 40;
      radius.value = 3.2;
      break;
    case LoaderSize.EXTRA_LARGE:
      size.value = 56;
      radius.value = 4.48;
      break;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "status",
    "aria-busy": "true",
    class: _normalizeClass({
      'loader-block-wrapper': !props.overlay,
      'loader-overlay-wrapper': props.overlay,
    })
  }, [
    (props.overlay)
      ? (_openBlock(), _createBlock(AppLoaderBackdrop, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({
        'loader-overlay-icon': props.overlay,
      })
    }, [
      (_openBlock(), _createElementBlock("svg", {
        width: size.value * 2,
        height: size.value * 2,
        viewBox: `0 0 ${size.value} ${size.value}`
      }, [
        _createVNode(AppLoaderCircle, {
          x: size.value * 0.5,
          y: size.value * 0.2,
          radius: radius.value,
          opacity: 1,
          begin: -0.875
        }, null, 8, ["x", "y", "radius", "begin"]),
        _createVNode(AppLoaderCircle, {
          x: size.value * 0.7,
          y: size.value * 0.3,
          radius: radius.value,
          opacity: 0.875,
          begin: -0.75
        }, null, 8, ["x", "y", "radius", "opacity", "begin"]),
        _createVNode(AppLoaderCircle, {
          x: size.value * 0.8,
          y: size.value * 0.5,
          radius: radius.value,
          opacity: 0.75,
          begin: -0.625
        }, null, 8, ["x", "y", "radius", "opacity", "begin"]),
        _createVNode(AppLoaderCircle, {
          x: size.value * 0.7,
          y: size.value * 0.7,
          radius: radius.value,
          opacity: 0.625,
          begin: -0.5
        }, null, 8, ["x", "y", "radius", "opacity", "begin"]),
        _createVNode(AppLoaderCircle, {
          x: size.value * 0.5,
          y: size.value * 0.8,
          radius: radius.value,
          opacity: 0.5,
          begin: -0.375
        }, null, 8, ["x", "y", "radius", "opacity", "begin"]),
        _createVNode(AppLoaderCircle, {
          x: size.value * 0.3,
          y: size.value * 0.7,
          radius: radius.value,
          opacity: 0.375,
          begin: -0.25
        }, null, 8, ["x", "y", "radius", "opacity", "begin"]),
        _createVNode(AppLoaderCircle, {
          x: size.value * 0.2,
          y: size.value * 0.5,
          radius: radius.value,
          opacity: 0.25,
          begin: -0.125
        }, null, 8, ["x", "y", "radius", "opacity", "begin"]),
        _createVNode(AppLoaderCircle, {
          x: size.value * 0.3,
          y: size.value * 0.3,
          radius: radius.value,
          opacity: 0.125,
          begin: 0
        }, null, 8, ["x", "y", "radius", "opacity"])
      ], 8, _hoisted_1))
    ], 2)
  ], 2))
}
}

})